var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent, createRef } from "react";
import moment from "moment";
import { DateRange as ReactDateRange } from "react-date-range";
import { Input, Radio } from "@irati/ui/src/FormItem";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Button from "@irati/ui/src/Button";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { perkbox } from "@irati/ui/src/global/colors";
import { Para } from "@irati/ui/src/Labels";
import { DateRangeButton, BodyContainer, OverlayContainer, DatePickerContainer, PresetContainer, FromToContainer, ButtonContainer } from "./styled";
import { DatePreset } from "./types";
import { getStartAndEndDatesForPreset, createDateLabel } from "./helpers";
var DateRangePicker = /** @class */ (function (_super) {
    __extends(DateRangePicker, _super);
    function DateRangePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.container = createRef();
        _this.togglePicker = function () {
            var presets = _this.props.presets;
            var _a = _this.state, showPresets = _a.showPresets, showRanges = _a.showRanges, startDate = _a.startDate, endDate = _a.endDate, preset = _a.preset;
            if (!presets) {
                _this.toggleRangePicker();
            }
            else if (showPresets) {
                _this.togglePresetPicker(false);
            }
            else if (showRanges) {
                _this.toggleRangePicker(false);
            }
            else if (startDate && endDate && !preset) {
                _this.toggleRangePicker(true);
            }
            else {
                _this.togglePresetPicker(true);
            }
        };
        _this.togglePresetPicker = function (visible) {
            var _a = _this.state, startDate = _a.startDate, endDate = _a.endDate, showRanges = _a.showRanges, preset = _a.preset, previousPreset = _a.previousPreset;
            var returningWithoutChoosingDate = !startDate && !endDate && showRanges && previousPreset;
            _this.setState({
                showPresets: visible,
                showRanges: false,
                preset: returningWithoutChoosingDate ? previousPreset : preset,
                previousPreset: undefined,
                startDate: visible ? undefined : startDate,
                endDate: visible ? undefined : endDate
            });
        };
        _this.toggleRangePicker = function (visible) {
            var _a = _this.state, existingPreset = _a.preset, startDate = _a.startDate, endDate = _a.endDate, existingShowRanges = _a.showRanges;
            var showRanges = typeof visible === "undefined" ? !existingShowRanges : visible;
            _this.setState({
                showRanges: showRanges,
                showPresets: false,
                startDate: showRanges ? undefined : startDate,
                endDate: showRanges ? undefined : endDate,
                preset: visible ? undefined : existingPreset,
                previousPreset: visible ? existingPreset : undefined
            });
        };
        _this.getDateRangeFromState = function () {
            var _a = _this.state, startDate = _a.startDate, endDate = _a.endDate, preset = _a.preset;
            return {
                startDate: startDate,
                endDate: endDate,
                preset: preset
            };
        };
        _this.stateCallback = _this.props.onChange
            ? function () {
                var onChange = _this.props.onChange;
                if (onChange) {
                    onChange(_this.getDateRangeFromState());
                }
            }
            : function () { };
        _this.formatDateInput = function (value, previousValue) {
            var _a = _this.props.dateFormat, dateFormat = _a === void 0 ? "" : _a;
            var divider = _this.state.divider;
            var dateFormatSplit = dateFormat.split(divider);
            // prevents adding dividers when user deletes
            if ((value || "").length > (previousValue || "").length) {
                if (value.length === dateFormatSplit[0].length || value.length === dateFormatSplit.slice(0, 2).join(divider).length) {
                    return "" + value + divider;
                }
            }
            return value;
        };
        _this.changeInputStart = function (value) {
            var dateFormat = _this.props.dateFormat;
            var _a = _this.state, inputStartDate = _a.inputStartDate, startDate = _a.startDate, endDate = _a.endDate;
            var applyValue = _this.formatDateInput(value, inputStartDate);
            var newState = { inputStartDate: applyValue, startDate: startDate };
            var date = moment(value, dateFormat);
            if (date.isValid() && date.isSameOrBefore(moment()) && date.isSameOrBefore(moment(endDate))) {
                newState.startDate = date.toDate();
            }
            _this.setState(newState, _this.stateCallback);
        };
        _this.changeInputEnd = function (value) {
            var dateFormat = _this.props.dateFormat;
            var _a = _this.state, inputEndDate = _a.inputEndDate, startDate = _a.startDate, endDate = _a.endDate;
            var applyValue = _this.formatDateInput(value, inputEndDate);
            var newState = { inputEndDate: applyValue, endDate: endDate };
            var date = moment(value, dateFormat);
            if (date.isValid() && date.isSameOrBefore(moment()) && date.isSameOrAfter(moment(startDate))) {
                newState.endDate = date.toDate();
            }
            _this.setState(newState, _this.stateCallback);
        };
        _this.handleRange = function (_a) {
            var range1 = _a.range1;
            _this.setState(__assign({}, range1), _this.stateCallback);
        };
        _this.handleSave = function () {
            var onSave = _this.props.onSave;
            _this.setState({
                showPresets: false,
                showRanges: false,
                preset: undefined
            }, function () { return onSave(_this.getDateRangeFromState()); });
        };
        _this.handlePreset = function (preset) {
            if (preset === DatePreset.CUSTOM) {
                _this.toggleRangePicker(true);
                return;
            }
            var _a = getStartAndEndDatesForPreset(preset), startDate = _a[0], endDate = _a[1];
            _this.setState({
                startDate: startDate,
                endDate: endDate,
                preset: preset,
                showPresets: false
            }, function () {
                var onSave = _this.props.onSave;
                onSave(_this.getDateRangeFromState());
            });
        };
        _this.getOptionalDateLimit = function (limit) {
            return limit ? new Date() : undefined;
        };
        _this.getFormattedDate = function (date) {
            var dateFormat = _this.props.dateFormat;
            return date ? moment(date).format(dateFormat) : undefined;
        };
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        var _a = _this.props, startDate = _a.startDate, endDate = _a.endDate, preset = _a.preset, _b = _a.dateFormat, dateFormat = _b === void 0 ? "" : _b;
        var divider = (dateFormat.match(/\W/) || [])[0];
        _this.state = {
            startDate: startDate,
            endDate: endDate,
            preset: preset,
            showPresets: false,
            showRanges: false,
            divider: divider
        };
        return _this;
    }
    DateRangePicker.prototype.componentDidMount = function () {
        document.addEventListener("mousedown", this.onDocumentClick, false);
    };
    DateRangePicker.prototype.componentWillUnmount = function () {
        document.removeEventListener("mousedown", this.onDocumentClick, false);
    };
    DateRangePicker.prototype.onDocumentClick = function (e) {
        if (!this.container.current.contains(e.target)) {
            this.setState({
                showPresets: false,
                showRanges: false
            });
        }
    };
    DateRangePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, formatMessage = _a.formatMessage, dateFormat = _a.dateFormat, initialStartDate = _a.startDate, initialEndDate = _a.endDate, defaultToPreset = _a.defaultToPreset, disableCustom = _a.disableCustom, disablePast = _a.disablePast, disableFuture = _a.disableFuture, presets = _a.presets, rightAlign = _a.rightAlign;
        var _b = this.state, startDate = _b.startDate, endDate = _b.endDate, preset = _b.preset, showPresets = _b.showPresets, showRanges = _b.showRanges, inputStartDate = _b.inputStartDate, inputEndDate = _b.inputEndDate;
        var presetLabel = preset && "platform.dateRangePicker.preset." + preset;
        var specificRangeLabel = formatMessage({ id: "platform.dateRangePicker.button.specificDateRange" });
        var startDisplay = this.getFormattedDate(startDate);
        var endDisplay = this.getFormattedDate(endDate);
        var formClean = !startDate || !endDate || (moment(initialStartDate).isSame(startDate) && moment(initialEndDate).isSame(endDate));
        var customSelector = disableCustom ? [] : [{ label: specificRangeLabel, value: DatePreset.CUSTOM }];
        return (React.createElement(BodyContainer, { ref: this.container },
            React.createElement(DateRangeButton, { icon: "calendar", slim: true, onClick: this.togglePicker },
                React.createElement(React.Fragment, null,
                    (presetLabel && React.createElement(FormattedMessage, { id: presetLabel })) || (startDate && endDate && createDateLabel(startDate, endDate)) || (React.createElement(FormattedMessage, { id: "platform.dateRangePicker.button.default" })),
                    React.createElement("span", { className: showPresets || showRanges ? "upArrow" : "downArrow" },
                        React.createElement(Icon, { icon: IconTypes.chevronDown, size: 20 })))),
            (showPresets || showRanges) && (React.createElement(OverlayContainer, { rightAlign: rightAlign },
                (showPresets || !defaultToPreset) && (React.createElement(PresetContainer, null,
                    React.createElement(Radio, { name: "rangePreset", value: preset, options: presets === null || presets === void 0 ? void 0 : presets.concat(customSelector), onChange: this.handlePreset }))),
                !disableCustom && (showRanges || !defaultToPreset) && (React.createElement(DatePickerContainer, null,
                    presets && (React.createElement(Para, { onClick: function () { return _this.togglePresetPicker(true); } },
                        React.createElement("span", { className: "leftArrow" },
                            React.createElement(Icon, { icon: IconTypes.chevronDown })),
                        specificRangeLabel)),
                    React.createElement(FromToContainer, null,
                        React.createElement(Input, { name: "from", placeholder: dateFormat, value: inputStartDate || startDisplay, onChange: this.changeInputStart, label: "platform.dateRangePicker.label.from" }),
                        React.createElement(Input, { name: "to", placeholder: dateFormat, value: inputEndDate || endDisplay, onChange: this.changeInputEnd, label: "platform.dateRangePicker.label.to" })),
                    React.createElement(ReactDateRange, { onChange: this.handleRange, moveRangeOnFirstSelection: false, ranges: [{ startDate: startDate, endDate: endDate }], editableDateInputs: false, showDateDisplay: false, rangeColors: [perkbox.blue], minDate: this.getOptionalDateLimit(disablePast), maxDate: this.getOptionalDateLimit(disableFuture) }),
                    React.createElement(ButtonContainer, null,
                        React.createElement(Button, { id: "save", full: true, primary: true, onClick: this.handleSave, disabled: formClean },
                            React.createElement(FormattedMessage, { id: "platform.dateRangePicker.button.apply" })))))))));
    };
    DateRangePicker.defaultProps = {
        dateFormat: "DD-MM-YYYY",
        defaultToPreset: false,
        disableCustom: false,
        disablePast: false,
        disableFuture: false
    };
    return DateRangePicker;
}(PureComponent));
export default injectIntl(DateRangePicker);
